import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Register from "./pages/Register/Register";
import Home from "./pages/Home/Home";
import UsersReport from "./pages/Users/UsersReport";
import PrivateRoutes from "./components/PrivateRoute/PrivateRoute";
import AdminLogin from "./pages/AdminLogin/AdminLogin";

const Router = () => {
  return (
    <BrowserRouter basename={process.env.REACT_APP_SUBDIRECTORY}>
      <Routes>
        <Route path="/" element={<Register />} />
        <Route path="/users/login" element={<AdminLogin />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/speech-evaluation/:userId" element={<Home />} />
          <Route
            path="/users/list"
            element={<UsersReport />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
